export default "__VITE_ASSET__C2ZLjA5c__"